module.exports = __webpack_public_path__ + "static/media/google.08aaff30.svg";